var React = require('react');
var ReactNative = require('react-native');
var createReactClass = require('create-react-class');

var {
  AppRegistry,
  View,
  Image,
  Platform,
  findNodeHandle
} = ReactNative;

var HyperLink = createReactClass(
{
  getDefaultProps : function()
  {
    return {
    }
  },

  getInitialState : function()
  {
    return {
    }
  },

  componentDidMount : function()
  {
  },

  render: function()
  {
    return <View style={this.props.style} />
  }
});

module.exports = HyperLink;



// WEBPACK FOOTER //
// ./src/wrappers/react-native-hyperlink-wrapper.js